import itemFullcont from "./itemLost-fullcont.html";

const dialog            = require('../../../../../components/dialog/dialog')
const fullcontEntity    = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler   = require('../../../../../components/fullcont/fullcont-handler')
const itemDt            = require('./item-dt')
const { formCopy }      = require('./itemLost-fullcont-form')
const { form }          = require('./itemLost-fullcont-form')
const itemHandler       = require('./item-fullcont-handler')
const { itemMT }        = require('./item-fullcont-multitable')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

    fullcontHandler.HTMLselect(

        'inventory', //database table name****
        'item', //dest entity on js
        'itemLost-fullcont',
        itemFullcont, form, formCopy, itemMT,
        editDialog, deleteDialog, dtCall, htmlFc)

    HTMLwasSelected = true

    htmlFc.addOne = 'server/php/sql/insertPurchaseVsLost.php'

    // htmlFc.hasFiles = true
    // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {

    if (!HTMLwasSelected) { HTMLselect(detail) }

    obj[detail.act].start(detail)
}/**/


const obj = {

    addOne:             { start: (detail) => { addOne(detail, htmlFc)                               } },
    cancelEdit:         { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc)            } },
    discard:            { start: (detail) => { fullcontHandler.discard(detail, htmlFc)              } },
    hide:               { start: (detail) => { hide(detail, htmlFc)                  } },
    prepareAdd:         { start: (detail) => { prepareAdd(detail)                                   } },
    saveFromDialog:     { start: (detail) => { saveFromDialog(detail, htmlFc)                       } },
    processQtyItemLost: { start: (detail) => { itemHandler.processQtyItemLost(detail, htmlFc)  } },

}/**/

function hide(detail, htmlFc) {
    htmlFc.dest = 'itemLost'
    fullcontEntity.hide(detail, htmlFc)
}

function prepareAdd(detail) {
    fullcontEntity.prepareAdd(detail, htmlFc, (response) => { getItemInformation(response, detail) })
}

function getItemInformation(htmlFc, detail) {
    itemHandler.addDataDetail(detail, htmlFc);

    itemHandler.getItemInformation(detail, htmlFc)
}

//function to send
function editDialog() {
    dialog.start({ act: "show", id: "saveChanges", entity: 'item' })
}

function deleteDialog(detail) {
    dialog.start({ act: "show", dest: 'item', id: "deleteElem", entity: 'item', dbid: detail.dbid })
}

function dtCall(act, result) {
    //inventoryDt.start({act:act, row: result})
}

function addOne(detail, htmlFc) {
    if (itemHandler.validated(detail, htmlFc)) {
        fullcontEntity.addOne(detail, htmlFc, afterAddOne)
    }
}

function afterAddOne(data, result) {
    itemDt.start({ "dest": "item", "elem": "dt", "act": "select", "entity": "item" })
    itemHandler.getItemInformation({}, htmlFc)

    // para que despues de agregar un lost, vuelva a estar en modo add
    htmlFc.fullcontHTML.classList.remove('mode-view')
    htmlFc.fullcontHTML.classList.remove('mode-edit')
    htmlFc.fullcontHTML.classList.add('mode-add')

}

function saveFromDialog(detail, htmlFc) {
    if (itemHandler.validated(detail, htmlFc)) {
        fullcontEntity.saveFromDialog(detail, htmlFc, afterAddOne)
    }
}